// extracted by mini-css-extract-plugin
export default {"recommendationCardContainer":"RecommendationCardModal_recommendationCardContainer__3Nis5","tabsWithStatusWrapper":"RecommendationCardModal_tabsWithStatusWrapper__89Ppz"};